/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { useCallback, useEffect, useState } from 'react';

const useKeyboardNavigator = () => {
  const [isKeyboardNavigator, setIsKeyboardNavigator] = useState(false);
  const handleKeyboardNavigator = useCallback((e) => {
    if (!e || typeof e !== 'object') return;
    const formElements = ['input', 'select', 'textarea'];
    if (formElements.includes(e.target.tagName.toLowerCase())) return;
    if (e.type === 'mousedown') return setIsKeyboardNavigator(false);
    if (e.key === 'Tab' || e.code === 'Tab') return setIsKeyboardNavigator(true);
    return;
  }, []);

  useEffect(() => {
    window.addEventListener('mousedown', handleKeyboardNavigator);
    window.addEventListener('keydown', handleKeyboardNavigator);
    return () => {
      window.removeEventListener('mousedown', handleKeyboardNavigator);
      window.removeEventListener('keydown', handleKeyboardNavigator);
    };
  });

  return { isKeyboardNavigator };
};

export default useKeyboardNavigator;
